import { render, staticRenderFns } from "./GestaoVagasVisualizar.vue?vue&type=template&id=41260cb2&scoped=true"
import script from "./GestaoVagasVisualizar.vue?vue&type=script&lang=js"
export * from "./GestaoVagasVisualizar.vue?vue&type=script&lang=js"
import style0 from "./GestaoVagasVisualizar.vue?vue&type=style&index=0&id=41260cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41260cb2",
  null
  
)

export default component.exports